// hooks/useDeviceName.js
import { useState, useEffect } from "react";

const isIPadLike = (userAgent) =>
  /iPad/.test(userAgent) ||
  (navigator?.platform === "MacIntel" && navigator?.maxTouchPoints > 1);
const isIOSPhone = (userAgent) =>
  /iPhone|iPod/.test(userAgent) && !window.MSStream;
const isWindowsPhone = (userAgent) =>
  /Windows NT/.test(userAgent) && /Mobile/.test(userAgent);
const isMacMobile = (userAgent) =>
  /Macintosh/.test(userAgent) && /Mobile/.test(userAgent);
const isLinuxMobile = (userAgent) =>
  /Linux/.test(userAgent) && /Mobile/.test(userAgent);

const useDeviceName = () => {
  const [deviceName, setDeviceName] = useState("Unknown Device");

  useEffect(() => {
    const userAgent = navigator.userAgent;

    try{
      if (/android/i.test(userAgent)) {
        setDeviceName("Android Device (Mobile)");
      } else if (isIPadLike(userAgent)) {
        setDeviceName("iPad (Tablet)");
      } else if (isIOSPhone(userAgent)) {
        setDeviceName("iOS Device (Mobile)");
      } else if (isWindowsPhone(userAgent)) {
        setDeviceName("Windows Phone (Mobile)");
      } else if (/Windows NT/.test(userAgent)) {
        setDeviceName("Windows PC");
      } else if (isMacMobile(userAgent)) {
        setDeviceName("Mac (Mobile)");
      } else if (/Macintosh/.test(userAgent)) {
        setDeviceName("Mac");
      } else if (isLinuxMobile(userAgent)) {
        setDeviceName("Linux Device (Mobile)");
      } else if (/Linux/.test(userAgent)) {
        setDeviceName("Linux PC");
      } else {
        setDeviceName("Unknown Device");
      }
    }catch (e) {
      console.log(e)
    }

  }, []);

  return deviceName;
};

export const isMobileDevice = () => {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isTablet = /iPad|Kindle|Tablet|PlayBook|SM-T/i.test(userAgent);
  return isMobile && !isTablet;
};
export default useDeviceName;
